import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("pg_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const adminApi = axios.create({ baseURL: API_BASE });
adminApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("pg_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const publicApi = axios.create({ baseURL: API_BASE });
